export const environment = {
  appName: 'Handyhand',
  appUrl: 'https://handyhand.nl',
  country: 'Netherlands',
  platformUrl: 'https://handyhand.nl/platform',
  production: true,
  env: 'production',
  supportEmail: 'support@handyhand.nl',
  supportPhone: '+31 20 1234567',
  apiUrl: 'https://api.handyhand.dk/api',
  apiV2Url: 'https://api-v2.handyhand.dk',
  vectorServiceUrl: 'https://vector.handyhand.dk/api',
  dashboardBaseRef: 'https://api-dashboard.handyhand.dk/',
  apiPrefix: 'nl/',
  resizeUrl: 'https://d3r2zfg0xujt92.cloudfront.net',
  cloudFrontImgUrl: 'https://d10a6kin4dgxel.cloudfront.net',
  domain: 'https://handyhand.nl',
  googleTagId: 'GTM-5T5GZ93',
  posthog: {
    key: 'phc_1yd61o75XIes1dLavzv1gnzG4zqyo3eROsstQAbGZ6P',
    host: 'https://eu.i.posthog.com',
  },
  social: {
    fb: 'https://nl-nl.facebook.com/handyhand',
    instagram: 'https://www.instagram.com/handyhand.nl/',
    linkedin: 'https://nl.linkedin.com/company/handy-hand',
  },
};
